<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="$router.back()" />
      </template>
      資格管理
    </Header>

    <div class="my-4 mx-3">
      <p class="mb-3 text-size-14 text-mild">
        より多くの資格証をご登録いただくと、応募可能な仕事が増えます
      </p>

      <QualificationItem
        v-for="qualification in supportedQualificationsByProduct"
        :key="qualification.id"
        :status="qualification.status"
        :to="{
          name: 'MypageEditQualification',
          params: { qualificationId: qualification.id }
        }"
        class="mt-2"
        >{{
          getQualificationName(qualification.qualification)
        }}</QualificationItem
      >

      <QualificationItem
        v-for="qualification in unSupportedQualificationsByProduct"
        :key="qualification.id"
        :status="qualification.status"
        :disabled="true"
        class="mt-2"
        >{{
          getQualificationName(qualification.qualification)
        }}</QualificationItem
      >

      <AddQualificationItem
        class="mt-2"
        @click.native="onClickAddQualification"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import AddQualificationItem from "@/components/molecules/other/AddQualificationItem.vue";
import QualificationItem from "@/components/molecules/other/QualificationItem.vue";
import { accountService } from "@/app/services/AccountService";
import { ErrorType, showErrorModal } from "@/utils/showErrorModal";
import { UserQualification } from "@/types/qualification/UserQualification";
import { authStore } from "@/store/auth";
import { masterStore } from "@/store/master";

@Component({
  components: {
    FeatherIcon,
    Header,
    AddQualificationItem,
    QualificationItem
  }
})
export default class MypageQualificationList extends Vue {
  qualifications: UserQualification[] = [];

  get user() {
    return authStore.user!;
  }

  get supportedQualificationIds() {
    return authStore.product.qualifications.map(q => q.id);
  }

  get supportedQualificationsByProduct() {
    return this.qualifications.filter(q =>
      this.supportedQualificationIds.includes(q.qualification)
    );
  }

  get unSupportedQualificationsByProduct() {
    return this.qualifications.filter(
      q => !this.supportedQualificationIds.includes(q.qualification)
    );
  }

  async created() {
    try {
      this.$loading.show();
      await Promise.all([
        // Storeの状態を最新にする
        accountService.updateUserData(),
        this.fetchQualifications()
      ]);
    } catch (error) {
      showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
    }
  }

  async fetchQualifications() {
    this.qualifications = (await accountService.fetchQualifications()).results;
  }
  getQualificationName(qualificationId: number) {
    return masterStore.qualificationMap.get(qualificationId)!.name;
  }

  onClickAddQualification() {
    if (this.user.hasRegisteredProfile) {
      this.$router.push({ name: "MypageAddQualification" });
      return;
    } else {
      this.$bvModal.msgBoxOk(
        "アカウント登録が完了していないため、資格を追加できません",
        {
          centered: true
        }
      );
    }
  }
}
</script>
